import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Autocomplete,
	Button,
	Card,
	CardContent,
	Grid,
	Typography,
	Box,
	Stack
} from "@mui/material";
import TextField from "@mui/material/TextField";
import floatParser from "../../../helpers/floatParser";
import {IHesap, IHesapHareketi, IKalem} from "../../../constants/types/logbook";
import IconButton from "@mui/material/IconButton";
import {Delete, Undo, MoveUp, AddCircleOutline, ExpandMore} from "@mui/icons-material";

const Transferler = (
	{
		transferler,
		setTransferler,
		hesaplar,
	}: {
		transferler: IKalem<IHesapHareketi>,
		setTransferler: any,
		hesaplar: IHesap[],
	}) => {
	return (
		<Accordion
			elevation={0}
			sx={{
				backgroundColor: 'background.paper',
				borderRadius: '16px !important',
				border: '1px solid rgba(0,0,0,0.05)',
				mb: 1,
				overflow: 'hidden',
				'&:before': { display: 'none' }
			}}
		>
			<AccordionSummary expandIcon={<ExpandMore />}>
				<Stack direction="row" spacing={1.5} alignItems="center">
					<MoveUp color="primary" />
					<Typography variant="h6" fontWeight={800} sx={{ textTransform: 'uppercase', letterSpacing: 1 }}>
						Transferler
					</Typography>
					<Typography variant="caption" sx={{ bgcolor: 'primary.main', color: 'white', px: 1, py: 0.2, borderRadius: 1, fontWeight: 700 }}>
						{transferler.data.length + transferler.eklenenListe.length} Kayıt
					</Typography>
				</Stack>
			</AccordionSummary>
			<AccordionDetails sx={{ bgcolor: '#fcfcfc', p: { xs: 1, md: 1.5 } }}>
				<Grid container spacing={1}>
				{
					transferler.data.map((transfer, transferIndex) => {
							const guncellenmis = transferler.guncellenecekIdListe.includes(transfer.id ?? -1);
							const silinmis = transferler.silinecekIdListe.includes(transfer.id ?? -1);
							if (guncellenmis) transfer = transferler.guncellenecekListe[transfer.id ?? 0];
							return (
								<Grid item xs={12} key={"transfer-" + transferIndex}>
									<Card
										elevation={0}
										sx={{
											border: '1px solid',
											borderColor: guncellenmis ? 'info.light' : silinmis ? 'error.light' : 'rgba(0,0,0,0.08)',
											backgroundColor: guncellenmis ? 'info.light' : silinmis ? '#fff5f5' : '#fff',
											borderRadius: '12px',
											transition: 'all 0.2s'
										}}
									>
										<CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
											<Grid container spacing={1} alignItems="center">
												<Grid item xs={12} sm={4}>
													<Autocomplete
														size={"small"}
														disablePortal
														disabled={silinmis}
														options={hesaplar.filter(q => q.hesapTipi !== "Çalışan")}
														getOptionLabel={option => option.hesapAdi ?? ""}
														disableClearable
														renderInput={(params) => <TextField {...params} label="Kaynak"/>}
														value={hesaplar.find(q => q.id === transfer.kaynak)}
														onChange={(_, value) => {
															const guncel = {...transfer};
															guncel.kaynak = value?.id;
															setTransferler({
																...transferler,
																guncellenecekIdListe: [...(guncellenmis ? transferler.guncellenecekIdListe : [...transferler.guncellenecekIdListe, transfer.id ?? 0])],
																guncellenecekListe: {...transferler.guncellenecekListe, [transfer.id ?? 0]: guncel}
															})
														}}
													/>
												</Grid>
												<Grid item xs={12} sm={4}>
													<Autocomplete
														size={"small"}
														disablePortal
														disabled={silinmis}
														options={hesaplar}
														getOptionLabel={option => option.hesapAdi ?? ""}
														disableClearable
														renderInput={(params) => <TextField {...params} label="Hedef"/>}
														value={hesaplar.find(q => q.id === transfer.hedef)}
														onChange={(_, value) => {
															const guncel = {...transfer};
															guncel.hedef = value?.id;
															setTransferler({
																...transferler,
																guncellenecekIdListe: [...(guncellenmis ? transferler.guncellenecekIdListe : [...transferler.guncellenecekIdListe, transfer.id ?? 0])],
																guncellenecekListe: {...transferler.guncellenecekListe, [transfer.id ?? 0]: guncel}
															})
														}}
													/>
												</Grid>
												<Grid item xs={12} sm={4}>
													<TextField
														size={"small"}
														fullWidth
														disabled={silinmis}
														type={"number"}
														label={"Tutar"}
														InputProps={{ endAdornment: <Typography variant="caption" sx={{ ml: 1, fontWeight: 700 }}>₺</Typography> }}
														value={"" + transfer.miktar}
														onChange={(event) => {
															const guncel = {...transfer};
															guncel.miktar = floatParser(event.target.value);
															setTransferler({
																...transferler,
																guncellenecekIdListe: [...(guncellenmis ? transferler.guncellenecekIdListe : [...transferler.guncellenecekIdListe, transfer.id ?? 0])],
																guncellenecekListe: {...transferler.guncellenecekListe, [transfer.id ?? 0]: guncel}
															})
														}}
													/>
												</Grid>
												<Grid item xs={12} sm={10}>
													<TextField
														size={"small"}
														fullWidth
														disabled={silinmis}
														type={"text"}
														label={"Açıklama"}
														value={transfer.aciklama}
														onChange={(event) => {
															const guncel = {...transfer};
															guncel.aciklama = event.target.value;
															setTransferler({
																...transferler,
																guncellenecekIdListe: [...(guncellenmis ? transferler.guncellenecekIdListe : [...transferler.guncellenecekIdListe, transfer.id ?? 0])],
																guncellenecekListe: {...transferler.guncellenecekListe, [transfer.id ?? 0]: guncel}
															})
														}}
													/>
												</Grid>
												<Grid item xs={12} sm={2}>
													<Stack direction="row" spacing={1} justifyContent={{ xs: 'center', sm: 'flex-end' }}>
														<IconButton
															size="small"
															disabled={silinmis}
															onClick={() => {
																setTransferler({
																	...transferler,
																	silinecekIdListe: [...transferler.silinecekIdListe, transfer.id ?? 0],
																})
															}}
															color={"error"}
															sx={{ bgcolor: 'error.light', '&:hover': { bgcolor: '#ffcdd2' } }}
														>
															<Delete fontSize="small" />
														</IconButton>
														<IconButton
															size="small"
															disabled={!guncellenmis && !silinmis}
															onClick={() => {
																if (guncellenmis) {
																	setTransferler({
																		...transferler,
																		guncellenecekIdListe: transferler.guncellenecekIdListe.filter(id => id !== transfer.id),
																	})
																} else {
																	setTransferler({
																		...transferler,
																		silinecekIdListe: transferler.silinecekIdListe.filter(id => id !== transfer.id),
																	})
																}
															}}
															color={"info"}
															sx={{ bgcolor: 'info.light', '&:hover': { bgcolor: '#b3e5fc' } }}
														>
															<Undo fontSize="small" />
														</IconButton>
													</Stack>
												</Grid>
											</Grid>
										</CardContent>
									</Card>
								</Grid>
							)
						}
					)
				}
				{
					transferler.eklenenListe.map((transfer, transferIndex) => {
							const guncelle = (guncel: IHesapHareketi) => {
								setTransferler({
									...transferler,
									eklenenListe: transferler.eklenenListe.map((t, index) => {
										if (index === transferIndex) return guncel;
										return t;
									})
								})
							}
							return (
								<Grid item xs={12} key={"transfer_ekle-" + transferIndex}>
									<Card
										elevation={0}
										sx={{
											border: '2px dashed',
											borderColor: 'success.main',
											backgroundColor: '#f1fff1',
											borderRadius: '12px'
										}}
									>
										<CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
											<Grid container spacing={1} alignItems="center">
												<Grid item xs={12} sm={4}>
													<Autocomplete
														size={"small"}
														disablePortal
														options={hesaplar.filter(q => q.hesapTipi !== "Çalışan").map(q => q.id)}
														getOptionLabel={option => hesaplar.find(q => q.id === option)?.hesapAdi ?? ""}
														disableClearable
														renderInput={(params) => <TextField {...params} label="Kaynak"/>}
														value={transfer.kaynak}
														onChange={(_, value) => {
															const guncel = {...transfer};
															guncel.kaynak = value;
															guncelle(guncel)
														}}
													/>
												</Grid>
												<Grid item xs={12} sm={4}>
													<Autocomplete
														size={"small"}
														disablePortal
														options={hesaplar.map(q => q.id)}
														getOptionLabel={option => hesaplar.find(q => q.id === option)?.hesapAdi ?? ""}
														disableClearable
														renderInput={(params) => <TextField {...params} label="Hedef"/>}
														value={transfer.hedef}
														onChange={(_, value) => {
															const guncel = {...transfer};
															guncel.hedef = value;
															guncelle(guncel)
														}}
													/>
												</Grid>
												<Grid item xs={12} sm={4}>
													<TextField
														size={"small"}
														fullWidth
														type={"number"}
														label={"Tutar"}
														InputProps={{ endAdornment: <Typography variant="caption" sx={{ ml: 1, fontWeight: 700 }}>₺</Typography> }}
														value={"" + transfer.miktar}
														onChange={(event) => {
															const guncel = {...transfer};
															guncel.miktar = floatParser(event.target.value);
															guncelle(guncel)
														}}
													/>
												</Grid>
												<Grid item xs={12} sm={11}>
													<TextField
														size={"small"}
														fullWidth
														type={"text"}
														label={"Açıklama"}
														value={transfer.aciklama}
														onChange={(event) => {
															const guncel = {...transfer};
															guncel.aciklama = event.target.value;
															guncelle(guncel)
														}}
													/>
												</Grid>
												<Grid item xs={12} sm={1} sx={{ display: 'flex', justifyContent: { xs: 'center', sm: 'flex-end' } }}>
													<IconButton
														size="small"
														onClick={() => {
															setTransferler({
																...transferler,
																eklenenListe: transferler.eklenenListe.filter((_, index) => index !== transferIndex),
															})
														}}
														color={"error"}
														sx={{ bgcolor: 'error.light', '&:hover': { bgcolor: '#ffcdd2' } }}
													>
														<Delete fontSize="small" />
													</IconButton>
												</Grid>
											</Grid>
										</CardContent>
									</Card>
								</Grid>
							)
						}
					)
				}
				<Grid item xs={12} sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
					<Button
						variant="outlined"
						startIcon={<AddCircleOutline />}
						onClick={() => {
							setTransferler({
								...transferler,
								eklenenListe: [
									...transferler.eklenenListe,
									{
										aciklama: "",
										miktar: 0,
										kaynak: 0,
										hedef: 0,
									}]
							})
						}}
						sx={{ 
							borderRadius: '10px', 
							textTransform: 'none', 
							fontWeight: 700,
							px: 4,
							borderWidth: '2px',
							'&:hover': { borderWidth: '2px' }
						}}
					>
						Yeni Transfer Ekle
					</Button>
				</Grid>
			</Grid>
		</AccordionDetails>
	</Accordion>
	);
}

export default Transferler;